import {
  FileText,
  LayoutDashboard,
  type LucideIcon,
  Presentation,
  Settings,
  SlidersHorizontal,
} from 'lucide-react';
import type { Role } from '@/lib/api/types';
import { hasRole } from '@/lib/auth';

export interface NavItem {
  /** Route path (also the nav key). */
  path: string;
  label: string;
  icon: LucideIcon;
  /** Minimum role to see and reach the item. Omit for any authenticated user. */
  requireRole?: Role;
  /**
   * Capability do PLANO (o eixo comercial do /v1/me) sem a qual o item sai da
   * navegação. `undefined` enquanto o /me não chegou MANTÉM o item: esconder e
   * reexibir seria flicker, e a rota tem o próprio guarda para o acesso direto.
   */
  requiresCapability?: string;
}

/** O item está visível para este papel E este plano? Plano desconhecido (o /me
 *  ainda viajando) não esconde nada — a decisão de sumir precisa de certeza. */
export function navItemVisible(
  item: NavItem,
  role: Role | undefined,
  planCapabilities: string[] | undefined,
): boolean {
  if (item.requireRole && !hasRole(role, item.requireRole)) return false;
  if (item.requiresCapability && planCapabilities !== undefined) {
    return planCapabilities.includes(item.requiresCapability);
  }
  return true;
}

/** The authenticated console lives under this base; "/" is the public landing. */
export const APP_BASE = '/app';

/**
 * A tela de todas as conversas (a busca no histórico). Não é item de navegação:
 * chega-se a ela pelo link do cabeçalho "Conversas" da barra e, no rail, pelo
 * ícone "Conversas".
 */
export const CONVERSATIONS_PATH = `${APP_BASE}/conversas`;

/**
 * The single source of truth for primary navigation: the side-nav renders it,
 * role and plan gating included, so a new screen joins the nav in one place.
 */
export const NAV_ITEMS: NavItem[] = [
  { path: APP_BASE, label: 'Visão geral', icon: LayoutDashboard },
  { path: '/app/conhecimento', label: 'Conhecimento', icon: FileText },
  { path: '/app/apresentacoes', label: 'Apresentações', icon: Presentation, requiresCapability: 'decks' },
  { path: '/app/configuracoes', label: 'Configurações', icon: Settings },
  { path: '/app/configuracoes-avancadas', label: 'Configurações avançadas', icon: SlidersHorizontal, requireRole: 'admin' },
];
